import './styles/RichList.scss';

import { Grid, Paper } from '@mui/material';

import clsx from 'clsx';
import { FunctionComponent, useState } from 'react';

import { Ordered } from 'app/containers/AWPM-FWPM/ModuleSelections/models';

import { Filter, FilterProps, Filters } from '../Filters';

interface HeadingProps {
  displayName: string;
  fieldName: string;
}

export interface RichListProps {
  controls?: FilterProps['controls'];
  sortable?: boolean;
  filters?: Filter[];
  onFilterChange?: FilterProps['onFilterChange'];
  onSortChange?: any;
  heading?: HeadingProps[];
  staticHeading?: React.ReactElement;
  defaultFilters?: FilterProps['defaultFilters'];
  className?: string;
  children: React.ReactNode;
}

export type GridWeight =
  | boolean
  | 'auto'
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | undefined;

export const buildListHeading = (
  items: Array<{ weight?: GridWeight; title: string; skip?: boolean }>,
  className: string
) => {
  return items
    .map(item => {
      if (item.skip) {
        return null;
      }
      return (
        <Grid item md={item.weight} className={className}>
          {item.title}
        </Grid>
      );
    })
    .filter(i => i !== null);
};

export const RichList: FunctionComponent<RichListProps> = props => {
  const [sortOptions, setSortOptions] = useState<{
    sort?: { name: string; direction: Ordered };
  }>({});

  const onSortClick = field => {
    const currentSortOptions = { ...sortOptions };
    if (!currentSortOptions.sort || currentSortOptions.sort.name !== field) {
      currentSortOptions.sort = {
        name: field,
        direction: Ordered.Ascending
      };
    } else {
      if (currentSortOptions.sort.direction === Ordered.Ascending) {
        currentSortOptions.sort.direction = Ordered.Descending;
      } else {
        currentSortOptions.sort.direction = Ordered.Ascending;
      }
    }
    setSortOptions(currentSortOptions);
    props.onSortChange!({
      sorting: JSON.stringify({
        [currentSortOptions.sort.name]: currentSortOptions.sort.direction
      })
    });
  };

  return (
    <div className={`richList ${props.className || ''}`}>
      {props.filters && (
        <Filters
          filterConfig={props.filters}
          controls={props.controls}
          defaultFilters={props.defaultFilters}
          onFilterChange={props.onFilterChange}
        />
      )}
      <div className="richList__content">
        {props.heading ? (
          <Grid container className="header" component={Paper} elevation={2}>
            {props.heading.map(h => (
              <Grid
                item
                xs
                className={clsx('column')}
                key={h.fieldName}
                onClick={() => onSortClick(h.fieldName)}
              >
                <span
                  className={clsx('column__name', {
                    'column__name--active': sortOptions.sort?.name === h.fieldName,
                    [`column__name--active--${sortOptions.sort?.direction.toLowerCase()}`]:
                      sortOptions.sort?.name === h.fieldName
                  })}
                >
                  {h.displayName}
                </span>
              </Grid>
            ))}
          </Grid>
        ) : (
          props.staticHeading
        )}
        <div className="body">{props.children}</div>
      </div>
    </div>
  );
};
